import { CollapsibleText as AntdCollapsibleText } from "@empglabs/backoffice-ui-kit"

const CollapsibleText = props => {
  return <AntdCollapsibleText {...props} />
}

export default CollapsibleText
